import React from 'react'
import styled from 'styled-components'

const Contact = () => {
  return (<Wrapper>
             <div className='section-center'>
                  <h3>Join our newsletter!</h3>
                  <div className='content'>
                       <p>We keep you posted as we unleash the latest trends, offer amazing discounts and routinely suprise our ardent customers...</p>
                        <form className='contact-form' action="https://formspree.io/f/mrgdakpz"
  method="POST">
                           <input type='email' className='form-input' placeholder='enter your email' name="email">
                           </input>
                           <button type='submit' className='submit-btn'>
                            Submit
                           </button>
                        </form>
                  </div>

            </div>
      </Wrapper>)
}
const Wrapper = styled.section`
  padding: 5rem 0;
  h3 {
    text-transform: none;
    color:rgb(237, 72, 152);
  }
  p {
    line-height: 2;
    max-width: 45em;
    color: var(--clr-grey-5);
    font-style:italic;
    font-size:1.3rem;
  }
  .contact-form {
    width: 90vw;
    max-width: 500px;
    display: grid;
    grid-template-columns: 1fr auto;
  }

  .form-input,
  .submit-btn {
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: 2px solid rgb(138, 12, 126);
  }
  .form-input {
    border-right: none;
    color: var(--clr-grey-3);

    border-top-left-radius: var(--radius);
    border-bottom-left-radius: var(--radius);
  }
  .submit-btn {
    border-top-right-radius: var(--radius);
    border-bottom-right-radius: var(--radius);
  }
  .form-input::placeholder {
     color:rgb(107, 79, 104);
    text-transform: capitalize;
  }
  .submit-btn {
    background: rgb(237, 182, 72);
    text-transform: capitalize;
    letter-spacing: var(--spacing);
    cursor: pointer;
    transition: var(--transition);
    color: white;
  }
  .submit-btn:hover {
  
    background:rgb(179, 128, 26);
  }
  @media (min-width: 992px) {
    .content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      gap: 8rem;
      margin-top: 2rem;
    }
    p {
      margin-bottom: 0;
    }
  }
  @media (min-width: 1280px) {
    padding: 5rem 0;
    padding-top:10rem;
  }
`

export default Contact
